import axios from 'axios';

import { getUserUuidHeaders } from '../../../utils/httpUtils';
import { getUrls } from '../../../utils/url';

const { api } = getUrls();

export const getStudent = async (meetingId, studentId, userUuid) => {
    const response = await axios.get(`${api}/api/zoom/get_class_student`, {
        params: {
            meeting_id: meetingId,
            student_id: studentId
        },
        headers: getUserUuidHeaders(userUuid)
    });

    return response.data;
};
